import Dashboard from "./Component.jsx";

export {
  Dashboard
};
